import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import CardSpacer from '../CardSpacer/CardSpacer';
import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class AccountsSection extends React.Component {
  render() {
    const { classes, rentBalance, maintenanceBalance, help } = this.props;

    const stringsComponent = 'accountsSection';

    return (
      <div className={classes.root}>
        <Grid container className='DashGridContainer'>
          <Grid item xs={12} className={`${classes.gridColumn} DashGridColumn`}>
            {rentBalance}
            <CardSpacer />
            {maintenanceBalance}
          </Grid>
          <Grid
            item
            xs={12}
            className={`${classes.gridColumn} DashGridColumn ${classes.helpContainer}`}
          >
            <CardSpacer />
            {help}
          </Grid>
        </Grid>
      </div>
    );
  }
}

AccountsSection.propTypes = {
  classes: PropTypes.object.isRequired,
  rentBalance: PropTypes.object.isRequired,
  maintenanceBalance: PropTypes.object.isRequired,
  help: PropTypes.object,
};

AccountsSection.defaultProps = {};

export default withStyles(styles)(AccountsSection);
